import { findInvite, Invite } from "apis/auth.api";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ServerState } from "utils/serverState";

export const useInvite = (uid: string, onSuccess: (data: Invite) => void) =>
  useQuery<Invite, AxiosError>(ServerState.INVITE, () => findInvite(uid), {
    onSuccess,
  });
